import { ScholarshipSponsorshipMap } from 'types';

export interface IFetchErrorParams {
  courseFee?: number;
  courseScholarshipAmount1?: number;
}

export function getCourseScholarships(
  courseName: string | undefined,
  courseFee: number | undefined,
  scholarshipSponsorship: ScholarshipSponsorshipMap | undefined,
): ScholarshipSponsorshipMap {
  const validScholarshipSponsorship: ScholarshipSponsorshipMap = scholarshipSponsorship || {};
  const courseScholarshipsObj: ScholarshipSponsorshipMap = {};
  Object.keys(validScholarshipSponsorship)
    .filter(key => {
      const isDummyScholarship =
        validScholarshipSponsorship[key]?.scholarshipName === 'University Scholarship' &&
        validScholarshipSponsorship[key]?.courseFundAmount === 0;
      const isUniScholarship = validScholarshipSponsorship[key]?.sponsorshipCovers?.includes(courseName || '');
      return isUniScholarship && !isDummyScholarship;
    })
    .forEach(key => {
      const scholarship = { ...validScholarshipSponsorship[key] };
      if (scholarship.courseFundType === 'Full' || scholarship.courseAndLivingFundType === 'Full') {
        scholarship.courseFundType = 'Amount';
        scholarship.courseFundAmount = courseFee || 0;
      } else if (scholarship.courseFundType === 'Percentage') {
        scholarship.courseFundType = 'Amount';
        scholarship.courseFundAmount = Math.floor(courseFee ? (courseFee * scholarship.courseFundPercentage) / 100 : 0);
      }
      courseScholarshipsObj[key] = scholarship;
    });
  return courseScholarshipsObj;
}

export function calculateScholarshipsSum(courseScholarships: ScholarshipSponsorshipMap | undefined): number {
  if (!courseScholarships) return 0;

  const validScholarshipSponsorship: ScholarshipSponsorshipMap = courseScholarships || {};
  return Object.values(validScholarshipSponsorship).reduce((acc, obj) => {
    return acc + obj.courseFundAmount;
  }, 0);
}

export function calculateFeeAfterScholarships(
  courseFee: number | undefined,
  courseScholarships: ScholarshipSponsorshipMap | undefined,
): number {
  if (!courseFee) return 0;

  const scholarshipSum = calculateScholarshipsSum(courseScholarships);

  if (courseFee - scholarshipSum > 0) return courseFee - scholarshipSum;
  return 0;
}
